/**
 * locales/es.js — Catálogo español (es-ES), fuente de verdad del idioma `es`.
 *
 * El copy de aquí coincide con el español de España ya corregido del storefront
 * (tuteo, talla, coste, importe, "Finalizar compra", EUR). Es la capa i18n liviana
 * SIN vue-i18n: las claves se resuelven contra este catálogo y `en.js` es un overlay.
 *
 * Uso: `t('nav.products')` → "Todos los productos". Placeholders `{nombre}` se
 * interpolan con el parámetro `params` de `t(key, { nombre: 'X' })`.
 */

export default {
  // ── Navbar ──────────────────────────────────────────────────────────────
  'nav.products': 'Todos los productos',
  'nav.news': 'Ofertas',
  'nav.contact': 'Contacto',
  'nav.collections': 'Colecciones',
  'nav.account': 'Cuenta',
  'nav.myAccount': 'Mi cuenta',
  'nav.viewCart': 'Ver carrito',
  'nav.search': 'Buscar productos',
  'nav.openMenu': 'Abrir menú',
  'nav.closeMenu': 'Cerrar menú',
  'nav.viewAll': 'Ver todo',
  'nav.shippingSpain': 'Envíos a España con GLS',
  'nav.shippingIntl': 'Envíos a España con GLS',

  // ── Footer ──────────────────────────────────────────────────────────────
  'footer.home': 'Inicio',
  'footer.contact': 'Contacto',
  'footer.faq': 'FAQ',
  'footer.terms': 'Términos y condiciones',
  'footer.privacy': 'Política de privacidad',
  'footer.refunds': 'Política de reembolsos',
  'footer.shippingPolicy': 'Política de envíos',

  // Columnas del footer
  'footer.colShop': 'Tienda',
  'footer.colNav': 'Navegación',
  'footer.colLegal': 'Legal',
  'footer.colContact': 'Contacto',
  'footer.products': 'Productos',
  'footer.cart': 'Carrito',

  // ── Idioma ──────────────────────────────────────────────────────────────
  'language.select': 'Idioma',
  'language.es': 'Español',
  'language.en': 'English',

  // ── Home ────────────────────────────────────────────────────────────────
  'home.heroCta': 'Colección 5 Stars',
  'home.categories': 'Categorías',
  'home.buy': 'Comprar',
  'home.viewAll': 'Ver todo',
  'home.viewCaps': 'Ver gorras',
  'home.viewAccessories': 'Ver accesorios',
  'home.viewCatalog': 'Ver catálogo',
  'home.latestDrops': 'Últimos drops',
  'home.heroName': 'Hero principal',
  'home.capsBannerName': 'Banner gorras',
  'home.capsBannerSubtitle': 'Nuestra pieza insignia: materiales premium y estética minimal.',
  'home.shopCategory': 'IR A COLECCIÓN',
  'home.showcaseProgress': 'Progreso de {title}',
  'home.stepOf': 'Paso {index} de {total}',

  // ── Catálogo / producto ────────────────────────────────────────────────
  'catalog.newIn': 'NOVEDADES',
  'catalog.offer': 'OFERTA',
  'catalog.soldOut': 'SOLD OUT',
  'catalog.viewAllFor': 'Ver todos los resultados para "{query}"',
  'catalog.noResults': 'No se encontraron productos',
  'catalog.selectType': 'Seleccionar {name}',
  'catalog.sort': 'Ordenar',
  'catalog.category': 'Categoría',
  'catalog.results': 'Resultados',
  'catalog.onSale': 'En oferta',
  'product.selected': 'Seleccionado',
  'product.noDescription': 'No hay descripción disponible para este producto.',
  'product.addToCart': 'Añadir al carrito',
  'product.adding': 'Añadiendo',
  'product.added': 'Añadido',
  'product.selectColor': 'Seleccionar color',
  'product.availableStock': 'Stock disponible',

  // ── Recomendador de tallas ──────────────────────────────────────────────
  'size.ask': '¿Qué talla debería elegir?',
  'size.dialog': 'Recomendador de tallas',
  'size.close': 'Cerrar',
  'size.subtitle': 'Cuéntanos tu altura y tu peso y te recomendamos la talla que mejor se ajusta a esta prenda.',
  'size.disclaimer': 'La recomendación es orientativa. Consulta la guía de tallas.',
  'size.height': 'Tu altura',
  'size.weight': 'Tu peso',
  'size.example': 'Ej. {value}',
  'size.recommend': 'Recomendar talla',
  'size.calculating': 'Calculando…',
  'size.recommended': 'Te recomendamos',
  'size.closestAvailable': '(la talla más cercana disponible para este producto)',
  'size.alternatives': 'También te puede ir bien:',
  'size.size': 'Talla',
  'size.chart': 'Guía de tallas',
  'size.completeMeasurements': 'Completa tu altura y tu peso para poder recomendarte.',
  'size.heightRange': 'La altura debe estar entre 100 y 250 cm.',
  'size.weightRange': 'El peso debe estar entre 30 y 250 kg.',
  'size.unavailable': 'No pudimos calcular una recomendación para este producto.',
  'size.calculate': 'Calcular',
  'size.recalculate': 'Volver a calcular',
  'size.gotIt': 'Entendido',

  // ── Carrito / checkout ──────────────────────────────────────────────────
  'cart.processing': 'Procesando...',
  'cart.redirecting': 'Redirigiendo...',
  'cart.confirmingOrder': 'Confirmando pedido...',
  'cart.redirectingPaypal': 'Redirigiendo a PayPal...',
  'cart.checkout': 'Finalizar compra',
  'cart.added': 'Añadido',
  'cart.yourCart': 'Tu carrito',
  'cart.closeCart': 'Cerrar carrito',
  'cart.empty': 'Tu carrito está vacío',
  'cart.subtotal': 'Subtotal',
  'cart.emptyDesc': 'Descubre nuestros productos y comienza tu compra.',
  'cart.viewProducts': 'Ver productos',
  'cart.orderSummary': 'Resumen del pedido',
  'cart.paymentMethod': 'Método de pago',
  'cart.payWithPayPal': 'Pagar con PayPal',
  'cart.payWithStripe': 'Tarjeta, Google Pay o Apple Pay',
  'cart.stripeUnavailable': 'El pago con Stripe no está disponible ahora. Elige otro método.',
  'cart.bankTransfer': 'Transferencia bancaria',
  'cart.bankTransferHint': 'Te enviamos los datos',
  'cart.continueWithYourData': 'O continúa con tus datos',
  'cart.contact': 'Contacto',
  'cart.emailHelpLabel': 'Más información sobre el email',
  'cart.emailHelpText': 'Te enviaremos la confirmación del pedido y el seguimiento a este email.',
  'cart.delivery': 'Entrega',
  'cart.deliveryCountry': 'País de entrega',
  'cart.countrySpain': 'España',
  'cart.companyOptional': 'Empresa (opcional)',
  'cart.street': 'Calle',
  'cart.addressHelpLabel': 'Más información sobre la dirección',
  'cart.addressHelpText': 'Escribe la calle de tu dirección de entrega.',
  'cart.number': 'Número / portal',
  'cart.addressDetails': 'Piso, puerta, escalera, etc. (opcional)',
  'cart.city': 'Ciudad',
  'cart.province': 'Provincia',
  'cart.postalCode': 'Código postal',
  'cart.neighborhood': 'Referencia de entrega (opcional)',
  'cart.phoneWithPrefix': 'Teléfono (+34)',
  'cart.phoneHelpLabel': 'Más información sobre el teléfono',
  'cart.phoneHelpText': 'Por si necesitamos contactarte sobre tu pedido. Incluye el prefijo (+34).',
  'cart.nifCif': 'NIF / NIE / CIF',
  'cart.shippingMethod': 'Método de envío',
  'cart.shippingPlaceholder': 'Ingresa tu dirección para ver los métodos de envío disponibles.',
  'cart.confirmOrder': 'Confirmar pedido',
  'cart.payNow': 'Pagar ahora',
  'cart.minPurchase': 'Importe mínimo {price}',
  'cart.continueShopping': 'Seguir comprando',
  'cart.noStock': 'No hay suficiente stock de {name}. Stock disponible: {stock}',
  'cart.couponPlaceholder': 'Código de descuento o gift card',
  'cart.apply': 'Aplicar',
  'cart.appliedTo': 'Aplicado a {eligible} de {total} productos',
  'cart.shipping': 'Envío',
  'cart.enterAddress': 'Introduce tu dirección',
  'cart.discount': 'Descuento',
  'cart.total': 'Total',
  'cart.minReached': 'Mínimo de pedido {price} alcanzado',
  'cart.minRemaining': 'Mínimo de pedido {price} — faltan {remaining}',

  // ── Detalle de producto ────────────────────────────────────────────────
  'product.description': 'Descripción',
  'product.sizeFit': 'Talla y ajuste',
  'product.shippingStandard': 'Estándar',
  'product.notFound': 'Producto no encontrado',
  'product.outOfStock': 'sin stock',
  'product.shippingStandardDays': '3–7 días hábiles',
  'product.shippingReturns': 'Envío / devoluciones',
  'product.shipStandardLine': 'Envío estándar: 3–7 días hábiles',
  'product.notFoundDesc': 'El producto que buscas no existe o no está disponible.',
  'product.backToProducts': 'Volver a productos',
  'product.closeColorPicker': 'Cerrar selector de color',
  'product.sizeLabel': 'Talla: {value}',
  'product.composition': 'Composición: {value}',

  // ── Cuenta / auth ───────────────────────────────────────────────────────
  'auth.login': 'Iniciar sesión',
  'auth.register': 'Crear cuenta',
  'auth.accountAccess': 'Acceso a cuenta',
  'auth.recoverHere': 'Recupérala aquí',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.signingIn': 'Iniciando sesión...',
  'auth.email': 'Email',
  'auth.password': 'Contraseña',
  'auth.confirmPassword': 'Confirmar contraseña',
  'auth.firstName': 'Nombre',
  'auth.lastName': 'Apellido',
  'auth.username': 'Usuario',
  'auth.nif': 'NIF / NIE',
  'auth.phone': 'Teléfono',
  'auth.creatingAccount': 'Creando cuenta...',
  'account.myOrders': 'Mis Pedidos',
  'account.myAccount': 'Mi cuenta',
  'account.logout': 'Cerrar sesión',
  'account.addresses': 'Direcciones de envío',
  'account.personalData': 'Datos personales',
  'account.nav.orders': 'Pedidos',
  'account.nav.settings': 'Configuración',
  'account.nav.contact': 'Contacto',
  'account.dashboard': 'Mi Panel',
  'account.welcome': '¡Bienvenido, {name}!',
  'account.welcomeSubtitle': 'Aquí puedes ver tus pedidos y gestionar tu cuenta.',
  'account.user': 'Usuario',
  'account.totalOrders': 'Pedidos Totales',
  'account.lastOrder': 'Último Pedido',
  'account.noOrders': 'Sin pedidos',
  'account.status': 'Estado',
  'account.regularCustomer': 'Cliente Regular',
  'account.recentOrders': 'Pedidos Recientes',
  'account.viewAll': 'Ver Todos',
  'account.thOrderNo': 'Nº Pedido',
  'account.thDate': 'Fecha',
  'account.thTotal': 'Total',
  'account.thStatus': 'Estado',
  'account.thActions': 'Acciones',
  'account.viewDetails': 'Ver Detalles',
  'account.noRecentOrders': 'No tienes pedidos recientes',
  'account.startShopping': 'Comenzar a Comprar',
  'account.errorLoadingOrders': 'Error al cargar los pedidos',
  'account.statusPending': 'Pendiente',
  'account.statusPaid': 'Pagado',
  'account.statusPreparing': 'En preparación',
  'account.statusShipped': 'Enviado',
  'account.statusDelivered': 'Entregado',
  'account.statusCancelled': 'Cancelado',
  'account.orders.reqStatusPending': 'Pendiente',
  'account.orders.reqStatusApproved': 'Aprobada',
  'account.orders.reqStatusRejected': 'Rechazada',
  'account.orders.reqStatusAwaitingReturn': 'Esperando devolución',
  'account.orders.reqStatusReceived': 'Recibida',
  'account.orders.reqStatusConfirmed': 'Confirmada',
  'account.orders.reqStatusCompleted': 'Completada',

  // ── Panel: direcciones ───────────────────────────────────────────────────
  'addr.manageIntro': 'Gestiona tus direcciones para agilizar tus compras',
  'addr.add': 'Añadir dirección',
  'addr.loading': 'Cargando direcciones...',
  'addr.noneTitle': 'No tienes direcciones guardadas',
  'addr.noneHint': 'Añade una dirección para agilizar tus compras.',
  'addr.addFirst': 'Añadir mi primera dirección',
  'addr.defaultBadge': 'Predeterminada',
  'addr.editAria': 'Editar',
  'addr.deleteAria': 'Eliminar',
  'addr.floorWord': 'Piso',
  'addr.aptWord': 'Dpto',
  'addr.cpWord': 'CP',
  'addr.setDefault': 'Usar como predeterminada',
  'addr.modalEdit': 'Editar dirección',
  'addr.modalNew': 'Nueva dirección',
  'addr.closeAria': 'Cerrar',
  'addr.labelOpt': 'Etiqueta (opcional)',
  'addr.labelPh': 'Ej: Casa, Oficina, etc.',
  'addr.street': 'Calle *',
  'addr.streetPh': 'Nombre de la calle',
  'addr.number': 'Número *',
  'addr.floor': 'Piso',
  'addr.floorPh': 'Ej: 3',
  'addr.apartment': 'Departamento',
  'addr.aptPh': 'Ej: A',
  'addr.city': 'Ciudad *',
  'addr.cityPh': 'Ciudad',
  'addr.province': 'Provincia *',
  'addr.selectProvince': 'Selecciona una provincia',
  'addr.postalCode': 'Código Postal *',
  'addr.useDefault': 'Usar como dirección predeterminada',
  'addr.cancel': 'Cancelar',
  'addr.saveChanges': 'Guardar cambios',
  'addr.addSubmit': 'Agregar dirección',
  'addr.updated': 'Dirección actualizada',
  'addr.added': 'Dirección agregada',
  'addr.saveError': 'Error al guardar la dirección',
  'addr.deleteConfirm': '¿Eliminar la dirección "{name}"?',
  'addr.deleted': 'Dirección eliminada',
  'addr.deleteError': 'Error al eliminar la dirección',
  'addr.defaultUpdated': 'Dirección predeterminada actualizada',
  'addr.defaultError': 'Error al actualizar la dirección predeterminada',
  'addr.loadError': 'Error al cargar las direcciones',

  // ── Panel: contacto ──────────────────────────────────────────────────────
  'contact.viewProfile': 'Ver perfil',
  'account.contactSubtitle': 'Escríbenos por tu pedido, cambios de cuenta o cualquier consulta de compra.',
  'account.contactSendTitle': 'Enviar un mensaje',
  'account.contactHint': 'Respondemos lo antes posible, de lunes a viernes.',
  'account.contactName': 'Nombre',
  'account.contactNamePh': 'Tu nombre',
  'account.contactSubject': 'Asunto',
  'account.contactSubjectPh': '¿Sobre qué nos escribes?',
  'account.contactMessagePh': 'Cuéntanos en detalle...',
  'account.contactSent': 'Mensaje enviado correctamente',
  'account.contactError': 'No pudimos enviar el mensaje',

  // ── Panel: pedidos ───────────────────────────────────────────────────────
  'ord.subtitle': 'Seguimiento de compras, datos de entrega y pagos.',
  'ord.refresh': 'Actualizar',
  'ord.filtersAria': 'Filtrar pedidos por estado',
  'ord.loading': 'Cargando tus pedidos...',
  'ord.empty': 'No tienes pedidos realizados aún',
  'ord.goShop': 'Ir a la tienda',
  'ord.number': 'Pedido #{id}',
  'ord.productOne': 'producto',
  'ord.productsMany': 'productos',
  'ord.unitOne': 'unidad',
  'ord.unitsMany': 'unidades',
  'ord.each': 'c/u',
  'ord.subtotalLbl': 'Subtotal:',
  'ord.noProductsInOrder': 'No hay productos en este pedido.',
  'ord.recipient': 'Destinatario',
  'ord.phone': 'Teléfono',
  'ord.shipping': 'Envío',
  'ord.address': 'Dirección',
  'ord.deliveryHome': 'Envío a domicilio',
  'ord.pickupStore': 'Recogida en tienda',
  'ord.productsTitle': 'Productos',
  'ord.unnamed': 'Producto sin nombre',
  'ord.productFallback': 'Producto',
  'ord.hideShipping': 'Ocultar envío',
  'ord.viewShippingDetails': 'Ver detalles del envío',
  'ord.feeShipping': 'Envío',
  'ord.totalLabel': 'Total del pedido:',
  'ord.paymentMethod': 'Medio de pago',
  'ord.paymentStatus': 'Estado del pago',
  'ord.paid': 'Pagado',
  'ord.paymentPending': 'Pendiente de pago',
  'ord.paymentPayPal': 'PayPal',
  'ord.paymentStripe': 'Tarjeta / Stripe',
  'ord.paymentBankTransfer': 'Transferencia bancaria',
  'ord.paymentOnline': 'Pago online',
  'ord.paymentCash': 'Efectivo',
  'ord.paymentUnknown': 'No especificado',
  'ord.coupon': 'Cupón {code}',
  'ord.discountApplied': 'Descuento aplicado',
  'ord.shipService': 'Servicio',
  'ord.shipCost': 'Coste',
  'ord.shipEstimated': 'Entrega estimada',
  'ord.shipDays': 'días',
  'ord.shipPostal': 'Código postal',
  'ord.redirecting': 'Redirigiendo...',
  'ord.payLinkError': 'No se pudo generar el link de pago.',
  'ord.payStartError': 'Error al iniciar el pago.',
  'ord.updated': 'Pedidos actualizados',
  'ord.notLoggedIn': 'No has iniciado sesión',
  'ord.loadError': 'Error al cargar los pedidos',
  'ord.unknownError': 'Error desconocido',
  'ord.paypalOrderIdError': 'No se pudo identificar la orden de PayPal.',
  'ord.emailDetailTitle': 'Detalle enviado por email',
  'ord.emailDetailPart1': 'Tu pedido #{id} ya figura en esta sección.',
  'ord.emailSentTo': 'Enviamos el detalle de compra a {email}.',
  'ord.emailSentRegistered': 'Enviamos el detalle de compra a tu email registrado.',
  'ord.gotIt': 'Entendido',
  'ord.filterAll': 'Todos',
  'ord.filterReview': 'En revisión',
  'ord.filterPaymentPending': 'Pago por confirmar',
  'ord.filterPaid': 'Pagados',
  'ord.filterPreparing': 'En preparación',
  'ord.filterShipped': 'Enviados',
  'ord.filterDelivered': 'Entregados',
  'ord.filterCancelled': 'Cancelados',
  'ord.stPending': 'En revisión',
  'ord.stPaymentPending': 'Pago por confirmar',
  'ord.stPaid': 'Pagado',
  'ord.stPreparing': 'En preparación',
  'ord.stShipped': 'Enviado',
  'ord.stDelivered': 'Entregado',
  'ord.stCancelled': 'Cancelado',
  'ord.retVerifyFailTitle': 'No pudimos verificar el pago',
  'ord.retVerifyFailMsg': 'No se encontró el pedido asociado al retorno del proveedor.',
  'ord.retCheckingTitle': 'Verificando pago del pedido #{id}',
  'ord.retCheckingMsg': 'Estamos sincronizando la confirmación del proveedor con tus pedidos.',
  'ord.retNotApprovedTitle': 'Pago no aprobado para el pedido #{id}',
  'ord.retNotApprovedMsg': 'El proveedor ha informado que el pago no fue aprobado. Puedes intentar pagarlo de nuevo desde esta lista.',
  'ord.retConfirmedTitle': 'Pago confirmado para el pedido #{id}',
  'ord.retConfirmedMsg': 'Actualizamos tu pedido. Ya puedes verlo marcado como pagado en la lista.',
  'ord.retPendingTitle': 'Pago por confirmar para el pedido #{id}',
  'ord.retPendingMsg': 'Estamos esperando la confirmación del pago. Puedes volver a revisar tus pedidos en unos minutos.',
  'ord.retPaypalUnclaimedMsg': 'PayPal recibió el pago, pero todavía figura como no reclamado en la cuenta vendedora. Cuando se acepte o complete en PayPal, el pedido podrá pasar a pagado.',
  'ord.retErrorTitle': 'No pudimos verificar el pago del pedido #{id}',
  'ord.retErrorMsg': 'Revisa tus pedidos o intenta actualizar la lista en unos segundos.',

  // ── Panel: ajustes de cuenta ─────────────────────────────────────────────
  'set.accountTitle': 'Configuración de cuenta',
  'set.accountSubtitle': 'Administra tus datos personales y la seguridad de tu cuenta.',
  'set.tabsAria': 'Secciones de configuración',
  'set.dataHint': 'Estos datos se usan para tus pedidos y la facturación.',
  'set.lastName': 'Apellido',
  'set.lastNamePh': 'Tu apellido',
  'set.emailPh': 'tu@email.com',
  'set.verify': 'Verificar',
  'set.phoneHint': 'Incluye el prefijo internacional (+34).',
  'set.dniHint': 'Documento fiscal para pedidos y facturación.',
  'set.companyPh': 'Nombre de la empresa',
  'set.verifyCode': 'Código de verificación',
  'set.cancelEmailAria': 'Cancelar cambio de email',
  'set.verifyCodeHint': 'Enviamos un código de verificación al nuevo email.',
  'set.emailAlert': 'Para cambiar tu email, introduce el código de verificación enviado a {email}',
  'set.saving': 'Guardando...',
  'set.changePassword': 'Cambiar contraseña',
  'set.pwdHint': 'Usa una contraseña segura que no uses en otros sitios.',
  'set.currentPassword': 'Contraseña actual',
  'set.currentPwdPh': 'Introduce tu contraseña actual',
  'set.newPwdPh': 'Introduce tu nueva contraseña',
  'set.confirmPwdPh': 'Confirma tu nueva contraseña',
  'set.hidePassword': 'Ocultar contraseña',
  'set.showPassword': 'Mostrar contraseña',
  'set.forgotPwd': '¿Olvidaste tu contraseña? Recupérala aquí',
  'set.changingPwd': 'Cambiando...',
  'set.secVerification': 'Verificación de seguridad',
  'set.secModalText': 'Por favor introduce tu contraseña para continuar con el cambio de email.',
  'set.modalPwdPh': 'Tu contraseña actual',
  'set.verifying': 'Verificando...',
  'set.continueBtn': 'Continuar',
  'set.recoveryText1': 'Te enviaremos un código de verificación a {email}.',
  'set.recoveryText2': 'Introduce el código que recibiste por email y elige tu nueva contraseña.',
  'set.confirmPwd': 'Confirmar contraseña',
  'set.processing': 'Procesando...',
  'set.errNameMin': 'El nombre debe tener al menos 2 caracteres',
  'set.errLastNameMin': 'El apellido debe tener al menos 2 caracteres',
  'set.errEmail': 'Introduce un email válido',
  'set.errDni': 'Introduce un NIF, NIE o CIF válido',
  'set.errPhone': 'Introduce un teléfono válido (mínimo 8 dígitos)',
  'set.errMinConfig': 'Error al actualizar el monto mínimo de compra',
  'set.errDollarRate': 'Error al actualizar la tasa del dólar',
  'set.errCenter': 'Error al procesar el centro de distribución {name}',
  'set.profileUpdated': 'Perfil actualizado correctamente',
  'set.profileUpdateError': 'Error al actualizar el perfil',
  'set.errEnterPwd': 'Por favor introduce tu contraseña',
  'set.codeSentNewEmail': 'Código de verificación enviado al nuevo email',
  'set.emailExists': 'Este email ya está registrado. Por favor utiliza otro email.',
  'set.wrongPassword': 'Contraseña incorrecta',
  'set.errRequestCode': 'Error al solicitar código de verificación',
  'set.errNoEmail': 'No se encontró un email asociado a tu cuenta',
  'set.codeSentEmail': 'Código de verificación enviado a tu email',
  'set.errRequestRecovery': 'Error al solicitar el código de recuperación',
  'set.errCode6': 'El código debe tener 6 dígitos',
  'set.errPwdMin': 'La contraseña debe tener al menos 6 caracteres',
  'set.errPwdMismatch': 'Las contraseñas no coinciden',
  'set.pwdRecovered': 'Contraseña restablecida correctamente',
  'set.errResetPwd': 'Error al restablecer la contraseña',
  'set.emailUpdated': 'Email actualizado correctamente',
  'set.errCodeInvalid': 'El código de verificación es inválido o ha expirado',
  'set.errUpdateEmail': 'Error al actualizar el email',
  'set.errPwdCurrent': 'Introduce tu contraseña actual',
  'set.errPwdNew': 'Introduce la nueva contraseña',
  'set.errPwdNewMin': 'La nueva contraseña debe tener al menos 6 caracteres',
  'set.pwdUpdated': 'Contraseña actualizada correctamente',
  'set.errChangePwd': 'Error al cambiar la contraseña',
  'set.errLoadStoreConfig': 'No se pudo cargar la configuración de la tienda',
  'set.errLoadData': 'Error al cargar los datos',

  // ── FAQ / legal ─────────────────────────────────────────────────────────
  'faq.title': 'Preguntas frecuentes',
  'faq.viewAll': 'Ver todas',
  'faq.loading': 'Cargando…',
  'legal.privacy': 'Política de Privacidad',
  'legal.terms': 'Términos y Condiciones',
  'legal.refunds': 'Política de Reembolsos',
  'legal.shipping': 'Envíos',

  // ── Contacto ────────────────────────────────────────────────────────────
  'contact.title': 'Contacto',
  'contact.subject': 'Consulta',
  'contact.send': 'Enviar consulta',
  'contact.sendMessage': 'Enviar mensaje',
  'contact.sending': 'Enviando...',
  'contact.customerService': 'Atención al cliente',
  'contact.directChannels': 'Canales directos',
  'contact.message': 'Mensaje',

  // ── Recuperar contraseña ────────────────────────────────────────────────
  'auth.recoverPassword': 'Recuperar contraseña',
  'auth.sendCode': 'Enviar código',
  'auth.newPassword': 'Nueva contraseña',
  'auth.setNewPassword': 'Establece tu nueva contraseña',
  'auth.code6': 'Código de 6 dígitos',
  'auth.confirmNewPassword': 'Confirmar nueva contraseña',
  'auth.resetPassword': 'Restablecer contraseña',
  'auth.resetting': 'Restableciendo...',
  'auth.passwordReset': 'Contraseña restablecida',
  'auth.accountActivated': 'Cuenta activada',
  'auth.activationError': 'No pudimos activar la cuenta',
  'auth.verifyingEmail': 'Verificando email',
  'auth.validatingLink': 'Estamos validando el enlace de activación.',

  // ── Blog ────────────────────────────────────────────────────────────────
  'blog.title': 'Blog',
  'blog.loading': 'Cargando artículos...',
  'blog.noResults': 'No se encontraron artículos',
  'blog.tryOtherFilters': 'Intenta con otros filtros de búsqueda',
  'blog.share': 'Compartir artículo',
  'blog.related': 'Artículos Relacionados',
  'blog.notFound': 'Artículo no encontrado',
  'blog.notFoundDesc': 'El artículo que buscas no existe o no está disponible.',

  // ── Catálogo: textos del browser/drawer/estados vacíos ──────────────────
  'catalog.refine': 'Refinar',
  'catalog.loading': 'Cargando',
  'catalog.defaultTitle': 'Nuevos ingresos',
  'catalog.filtersAria': 'Filtros del catálogo',
  'catalog.closeFilters': 'Cerrar filtros',
  'catalog.sortFeatured': 'Destacados',
  'catalog.sortPriceAsc': 'Menor precio',
  'catalog.sortPriceDesc': 'Mayor precio',
  'catalog.size': 'Talla',
  'catalog.sizeNumeric': 'Talla numérica',
  'catalog.clear': 'Limpiar',
  'catalog.clearFilters': 'Limpiar filtros',
  'catalog.viewProducts': 'Ver {count} productos',
  'catalog.noResultsHint': 'Prueba a ajustar los filtros.',
  'catalog.youMayLike': 'También te puede gustar',
  'catalog.recProgress': 'Progreso de recomendaciones',
  'catalog.recStep': 'Paso {index} de {total}',
  'catalog.viewProduct': 'Ver producto',
  'catalog.viewColor': 'Ver {name}',
  'catalog.viewImage': 'Ver imagen {index}',
  'catalog.imageAlt': 'imagen {index}',
  'catalog.alternateView': 'vista alternativa',
  'catalog.colorsAria': 'Colores disponibles',
  'catalog.colorsCount': '{count} colores',

  // ── Buscador (drawer de búsqueda) ───────────────────────────────────────
  'search.title': 'Buscar',
  'search.placeholder': '¿Qué estás buscando?',
  'search.close': 'Cerrar búsqueda',
  'search.clear': 'Limpiar búsqueda',
  'search.noResults': 'Sin resultados',
  'search.noResultsFor': 'No hemos encontrado productos para "{query}"',
  'search.viewFullCatalog': 'Ver catálogo completo',
  'search.typeToStart': 'Escribe para buscar productos',
  'search.viewAll': 'Ver todos',
  'search.viewAllResults': 'Ver todos los resultados para "{query}"',
  'search.result': 'resultado',
  'search.results': 'resultados',

  // ── Carrito: accesibilidad ──────────────────────────────────────────────
  'cart.qtyDecrease': 'Disminuir cantidad',
  'cart.qtyIncrease': 'Aumentar cantidad',
  'cart.removeItem': 'Eliminar producto',

  // ── Títulos de página (document.title del storefront) ───────────────────
  'page.home': 'Inicio',
  'page.products': 'Productos',
  'page.product': 'Producto',
  'page.blog': 'Blog',
  'page.terms': 'Términos y Condiciones',
  'page.privacy': 'Política de Privacidad',
  'page.refunds': 'Política de Reembolsos',
  'page.shipping': 'Envíos',
  'page.contact': 'Contacto',
  'page.cart': 'Carrito de Compras',
  'page.paymentWait': 'Preparando pago',
  'page.login': 'Iniciar Sesión',
  'page.register': 'Crear Cuenta',
  'page.verifyEmail': 'Verificar Email',
  'page.recoverPassword': 'Recuperar Contraseña',
  'page.gls': 'Puntos de entrega GLS',


  // ── TASK-032 keys imported on merge (used by integrated code) ──
  "account.orders.back": "Volver",
  "account.orders.cancelOrder": "Cancelar un pedido",
  "account.orders.cancelOrderDesc": "Si cambiaste de idea y el pedido todavía no fue enviado.",
  "account.orders.cancellation": "Cancelación",
  "account.orders.delivery": "Entrega",
  "account.orders.email": "Email",
  "account.orders.helpChooseAction": "Elige qué necesitas hacer con tu pedido.",
  "account.orders.helpReason": "Cuéntanos el motivo. Antes de enviar la solicitud, revisa la",
  "account.orders.needHelp": "¿Necesitas ayuda?",
  "account.orders.noAddress": "Sin dirección cargada",
  "account.orders.noEligibleOrders": "No tienes pedidos que admitan cancelación o devolución en este momento.",
  "account.orders.paymentFailedText": "Puedes ver tu pedido y reintentar el pago desde esta sección.",
  "account.orders.paymentFailedTitle": "No se pudo completar el pago",
  "account.orders.paymentPendingMsg": "Tu pedido quedó pendiente de pago.",
  "account.orders.providerRejected": "El proveedor de pago informó que el pago no fue aprobado.",
  "account.orders.reasonPlaceholder": "Motivo de la solicitud (obligatorio)",
  "account.orders.refundPolicyLink": "política de devoluciones y reembolsos",
  "account.orders.refundPolicySuffix": "(plazos y condiciones).",
  "account.orders.requestError": "Error al enviar la solicitud. Inténtalo de nuevo.",
  "account.orders.requestSentCancellation": "Solicitud de cancelación enviada. Te avisaremos por email.",
  "account.orders.requestSentReturn": "Solicitud de devolución enviada. Te avisaremos por email.",
  "account.orders.retryPayment": "Reintentar pago",
  "account.orders.return": "Devolución",
  "account.orders.returnProducts": "Devolver productos",
  "account.orders.returnProductsDesc": "Si ya recibiste el pedido y quieres devolverlo.",
  "account.orders.selectOrder": "Selecciona el pedido",
  "account.orders.sendRequest": "Enviar solicitud",
  "account.orders.sending": "Enviando...",
  "account.orders.status": "Estado",
  "account.orders.stripeStartError": "No se pudo iniciar el pago con tarjeta.",
  "account.orders.total": "Total",
  "account.orders.verifyProviderError": "No pudimos verificar el pago con el proveedor.",
  "account.orders.viewMyOrder": "Ver mi pedido",
  "admin.nav.abandonedCarts": "Carritos abandonados",
  "admin.nav.accountSettings": "Configuración",
  "admin.nav.addProduct": "Añadir producto",
  "admin.nav.addresses": "Direcciones",
  "admin.nav.adminSection": "ADMINISTRACIÓN",
  "admin.nav.categories": "Categorías",
  "admin.nav.closeMenu": "Cerrar menú",
  "admin.nav.coupons": "Cupones",
  "admin.nav.design": "Diseño",
  "admin.nav.general": "General",
  "admin.nav.legal": "Contenido legal",
  "admin.nav.logout": "Cerrar sesión",
  "admin.nav.marketing": "Marketing",
  "admin.nav.metrics": "Métricas",
  "admin.nav.myAccount": "Mi cuenta",
  "admin.nav.myOrders": "Mis pedidos",
  "admin.nav.newSale": "Nueva venta",
  "admin.nav.offers": "Ofertas",
  "admin.nav.openMenu": "Abrir menú",
  "admin.nav.pickElement": "Seleccionar elemento",
  "admin.nav.products": "Productos",
  "admin.nav.productsList": "Lista de productos",
  "admin.nav.profileSection": "PERFIL",
  "admin.nav.remitos": "Remitos",
  "admin.nav.requests": "Solicitudes",
  "admin.nav.sales": "Ventas",
  "admin.nav.salesList": "Lista de ventas",
  "admin.nav.shipping": "Envíos",
  "admin.nav.sizeCharts": "Tablas de tallas",
  "admin.nav.store": "Tienda",
  "admin.nav.storeSettings": "Configuración",
  "admin.nav.titleCoupons": "Cupones",
  "admin.nav.titleCustomers": "Clientes",
  "admin.nav.titleDashboard": "Panel de control",
  "admin.nav.titleOffers": "Ofertas",
  "admin.nav.titleOrders": "Mis pedidos",
  "admin.nav.titleOverview": "Panel general",
  "admin.nav.titleProducts": "Productos",
  "admin.nav.titleSales": "Ventas",
  "admin.nav.titleSettings": "Configuración",
  "admin.nav.titleStats": "Estadísticas",
  "admin.nav.titleStore": "Tienda",
  "admin.nav.translations": "Traducciones",
  "admin.nav.users": "Usuarios",
  "admin.nav.usersList": "Lista de usuarios",
  "checkout.couponApplied": "Cupón aplicado: {discount}",
  "checkout.couponAppliedTo": " (aplicado a {applied} de {total} productos)",
  "checkout.couponError": "Error al validar el cupón",
  "checkout.couponNotApplicable": "Este cupón no se puede aplicar a ninguno de los productos en tu carrito. Está destinado a productos de categorías específicas.",
  "checkout.couponRemoved": "Cupón removido",
  "checkout.couponRemovedNoEligible": "El cupón ha sido removido porque no hay productos elegibles en el carrito",
  "checkout.discountAmount": "{amount} de descuento",
  "checkout.discountPercent": "{percent}% de descuento",
  "checkout.discountUpTo": " (hasta {amount})",
  "checkout.eligibleOnly": " (solo para productos elegibles)",
  "checkout.insufficientStock": "No hay suficiente stock de {name}. Stock disponible: {stock}",
  "checkout.invalidCoupon": "Cupón no válido",
  "checkout.loginRequiredCoupon": "Debes iniciar sesión para usar un cupón",
  "checkout.noStock": "{name} no tiene stock disponible",
  "checkout.orderError": "Error al procesar la orden",
  "checkout.pricesChanged": "Los precios de {count} producto(s) han cambiado y fueron actualizados: {names}",
  "checkout.validate.deliveryRequired": "Selecciona un método de entrega",
  "checkout.validate.docInvalid": "Introduce un documento fiscal válido",
  "checkout.validate.docRequired": "El NIF/NIE/CIF es requerido",
  "checkout.validate.emailInvalid": "Ingresa un email válido",
  "checkout.validate.emailRequired": "El email es requerido",
  "checkout.validate.nameMinLength": "El nombre debe tener al menos 3 caracteres",
  "checkout.validate.nameRequired": "El nombre es requerido",
  "checkout.validate.paymentRequired": "Selecciona un método de pago",
  "checkout.validate.phoneInvalid": "Introduce un teléfono válido (mínimo 8 dígitos)",
  "checkout.validate.phoneRequired": "El teléfono es requerido",
  "checkout.validate.provinceRequired": "Selecciona una provincia",
  "notFound.backHome": "Volver al inicio",
  "notFound.desc": "Lo sentimos, la página que buscas no existe o ha sido movida.",
  "notFound.title": "Página no encontrada",
  "product.lastUnits": "Últimas {stock} unidades",
  "product.selectVariant": "Seleccionar {name}",
  "welcomePopup.notNow": "Ahora no",
}
